import { Link } from "react-router-dom";
import { Sun, CalendarDays, SlidersHorizontal, Timer } from "lucide-react";

export const APP_TABS = [
  { id: "today", label: "Today", icon: Sun },
  { id: "focus", label: "Focus", icon: Timer },
  { id: "history", label: "History", icon: CalendarDays },
  { id: "settings", label: "Settings", icon: SlidersHorizontal },
];

export const Brand = ({ onClick, light }) => (
  <Link to="/" onClick={onClick} data-testid="brand-ebbly" className="flex items-baseline gap-1">
    <span className={`font-heading text-2xl font-semibold tracking-tight ${light ? "text-[#f4e9e1]" : "text-[#3b2a24]"} dark:text-stone-100`}>Ebbly</span>
    <span className={`hidden sm:inline text-[10px] uppercase tracking-[0.25em] ${light ? "text-[#c3a99b]" : "text-[#8a6f64]"} dark:text-stone-500`}>capacity planner</span>
  </Link>
);
